/**
 * Killed story message
 * @author Ryan Gladstone
 * <story-killed-message story='story'></story-killed-message>
 */

function storyKilledMessage() {
  return {
    restrict: 'E',
    scope: {
      story: '='
    },
    template:
      `<div class='story-killed-bar' ng-show='story.kill.isKilled'>
        <p><i class='fa fa-trash'></i> <span twp-translate>STORY_REMOVED_MSG</span></p>
      </div>`
  };
}

export default function (ngModule) {
  ngModule.directive('storyKilledMessage', storyKilledMessage);
}
